// temporary component - to delete when changing cryo RA inhouse_grade into technical_evaluation
<template>
  <form>
    <p class="mt-0">Number of 1-day shifts</p>
    <b-form-select v-model="evaluation.number_of_shifts"
                   :disabled="!isEditable"
                   :options="shiftsOptions"/>

    <p>Acceptance mark</p>
    <extended-radio-group v-model="evaluation.acceptance_mark"
                          :disabled="!isEditable"
                          :options="acceptanceOptions"/>

    <p>Comment visible for USER<span class="grey--text font-italic"> (optional for approved)</span></p>
    <b-form-textarea v-model="evaluation.comment"
                     :disabled="!isEditable"
                     class="mb-3"
                     rows="3"/>
  </form>
</template>

<script>
  import ExtendedRadioGroup from '@/components/ExtendedRadioGroup';
  import { adaptListOfNamesToRadioOptions } from '@/helpers';

  export default {
    name: 'CryoemRapidAccessTechnicalEvaluationForm',
    components: { ExtendedRadioGroup },
    props: {
      value: {
        type: Object,
        required: true,
      },
      isEditable: {
        type: Boolean,
        required: true,
      },
      shiftsOptions: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        evaluation: {},
        acceptanceOptionsTexts: ['approved', 'rejected'],
      };
    },
    computed: {
      acceptanceOptions() {
        return adaptListOfNamesToRadioOptions(this.acceptanceOptionsTexts);
      },
    },
    watch: {
      value: {
        handler() {
          this.evaluation = this.value;
        },
        immediate: true,
      },
      evaluation: {
        handler() {
          this.$emit('input', this.evaluation);
        },
      },
    },
  };
</script>

<style scoped>
  p {
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
  }
</style>
